import React, { useState, memo } from "react";
import { DialogTitle, DialogContent } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MainButton from "../../shared/Button";
import { IconButtonMain, DialogMain } from "../accounting/styles/DialogStyles";
import { OrderDriverPopupMain } from "./styles/AssignOrderDriverPopupStyle";
import { AssignBroadcastOrdeds } from "../../../services/admin/dispatche";
import { toast } from "react-hot-toast";
import SelectDropDown from "../shared/SelectDropDown";

const BroadcastFormPopup = ({
  open,
  handleClose = () => {},
  order_id = "",
  orderPrice = "",
}) => {
  const [loading, setLoading] = useState(false);
  const [amount, setamount] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  const isSubmitDisabled = amount === "" || selectedOption === null;

  const options = [
    { value: "2", label: "2 miles" },
    { value: "4", label: "4 miles" },
    { value: "6", label: "6 miles" },
  ];

  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!amount) {
      toast.error("Amount is required.");
      return;
    }
    if (amount > orderPrice) {
      toast.error("Amount is not greater than order price.");
      return;
    }
    if (parseFloat(amount) < 0) {
      toast.error("Please enter a valid non-negative number.");
      return;
    }
    if (!selectedOption) {
      toast.error("Please select Radius.");
      return;
    }

    const DataObj = {
      type: "broadcast",
      driver_amount: amount,
      radius: selectedOption?.value,
    };

    const respon = await AssignBroadcastOrdeds(setLoading, order_id, DataObj);

    if (respon?.status === 200) {
      toast.success("Successfully Updated");
      setSelectedOption(null);
      setamount("");
    }
  };

  return (
    <>
      <DialogMain open={open} onClose={handleClose}>
        <DialogTitle>
          <div className="headerMain">
            <div className="title">
              <h6>Select radius to broadcast the job</h6>
            </div>
            <div className="closeBtn">
              <IconButtonMain onClick={handleClose}>
                <CloseIcon />
              </IconButtonMain>
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <OrderDriverPopupMain>
            <form onSubmit={handleSubmit}>
              <input
                type="number"
                placeholder="Enter amount"
                onChange={(e) => setamount(e.target.value)}
                value={amount}
              />
              <label>Select Radius</label>
              <SelectDropDown
                options={options}
                selectedOption={selectedOption}
                handleChange={handleChange}
                placeholder="Select Radius"
              />
              <MainButton
                type="submit"
                label="Broadcast Job"
                MT="10"
                disabled={isSubmitDisabled}
                isLoading={loading}
              />
            </form>
          </OrderDriverPopupMain>
        </DialogContent>
      </DialogMain>
    </>
  );
};

export default memo(BroadcastFormPopup);
